import { MIN_PASSWORD_LENGTH, MIN_USERNAME_LENGTH } from "./const";

const passwordValidations = [
  [(value: any) => !isEmpty(value), "Password is required!"],
  [
    (value: any) => value.length >= MIN_PASSWORD_LENGTH,
    `Password must be at least ${MIN_PASSWORD_LENGTH} characters!`
  ],
  [
    (value: any) => value.length <= 64,
    "Password must be less than 64 characters!"
  ],
  [(value: any) => !/\s/.test(value), "Password cannot contain spaces!"],
  [
    (value: any) => /[a-z]/.test(value),
    "Password must contain at least one lowercase letter!"
  ]
  // [
  //   (value: any) => /[A-Z]/.test(value),
  //   "Password must contain at least one uppercase letter!"
  // ],
  // [
  //   (value: any) => /[0-9]/.test(value),
  //   "Password must contain at least one number!"
  // ]
];

export function getEmailValidationSchema(values: any) {
  return {
    email: [
      [(value: any) => !isEmpty(value), "E-mail is required!"],
      [(value: any) => isEmail(value), "E-mail is not valid!"]
    ]
  };
}

export function getPasswordValidationSchema(values: any) {
  return {
    password: passwordValidations
  };
}

export function getProfileValidationSchema(values: any) {
  return {
    firstName: [[(value: any) => !isEmpty(value), "First name is required!"]],
    lastName: [[(value: any) => !isEmpty(value), "Last name is required!"]],
    username: [
      [(value: any) => !isEmpty(value), "Username is required!"],
      [
        (value: any) => value.length >= MIN_USERNAME_LENGTH,
        `Username has to be longer than ${MIN_USERNAME_LENGTH} characters!`
      ]
    ],
    email: [
      [(value: any) => !isEmpty(value), "E-mail is required!"],
      [(value: any) => isEmail(value), "E-mail is not valid!"]
    ],
    password: passwordValidations
  };
}

function isEmpty(value: any) {
  return !value || !value.trim();
}

function isEmail(value: any) {
  const EMAIL_REGEXP = /([\w\.\-_]+)?\w+@[\w-_]+(\.\w+){1,}/; // eslint-disable-line no-useless-escape
  return EMAIL_REGEXP.test(value);
}
